import { Dispatch, useCallback } from "react";

import { UpdateDtoResponse } from "../../../../Models/UpdateDtoResponse";
import { useGem } from "../../../../Utils/UseGem";
import { UserCampaignUpdates } from "./IvrUserSkillsConfig";

const usePutIvrUserCampaign = () => {
  const { res, loading, setReq } = useGem<UpdateDtoResponse[], UserCampaignUpdates>({
    method: "put",
    url: "Legacy/V0/ivr/users/campaigns"
  });
  const setRequest: Dispatch<UserCampaignUpdates> = useCallback(
    update => setReq(r => r && { ...r, payload: update }),
    []
  );

  return { res: res?.payload, loading, setRequest };
};

export default usePutIvrUserCampaign;
